var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFastFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30.24,
    viewBox: "0 0 32 30.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.621,27.305,1.688,8.88H.48A.515.515,0,0,1,0,8.361V6.427a3.117,3.117,0,0,1,2.788-3.1l.023-.49c0-.007,0-.014,0-.022A3.1,3.1,0,0,1,5.911,0h9.874a3.1,3.1,0,0,1,3.1,2.821.173.173,0,0,1,0,.022l.023.484a3.117,3.117,0,0,1,2.852,3.1V8.361a.515.515,0,0,1-.481.519H20.008l-.21,3.994-.438-.041v.447H2.875l.533,10.56H16.64v.96H3.457l.123,2.431A2.155,2.155,0,0,0,5.729,29.28H15.967a2.156,2.156,0,0,0,1.4-.513l.623.73a3.114,3.114,0,0,1-2.019.743H5.709A3.093,3.093,0,0,1,2.621,27.305Z",
    transform: "translate(0 0.08)",
    fill: "#425966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.765,20.32a.484.484,0,0,1-.47-.386L.01,9.005a.505.505,0,0,1,.1-.41A.511.511,0,0,1,.48,8.4H1.84V4.488A.478.478,0,0,1,2.308,4H4.08V2.3a.5.5,0,0,1,.514-.464H6.4V.479A.481.481,0,0,1,6.88,0H8.708A.489.489,0,0,1,9.2.479V2.16h1.12V.7A.433.433,0,0,1,10.765.24h1.829A.433.433,0,0,1,13.039.7V2.4h1.612a.472.472,0,0,1,.468.482V8.4h1.36a.5.5,0,0,1,.373.2.517.517,0,0,1,.1.418L14.664,19.94a.481.481,0,0,1-.47.381Z",
    transform: "translate(15.041 10)",
    fill: "#d84a4a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFastFood);
export default __webpack_public_path__ + "static/media/ic_fast-food.c7d435ef1f0424bceceafd15f4e051bf.svg";
export { ForwardRef as ReactComponent };